import { 
    FETCH_SITUACION_IVA, 
    FETCH_TIPOS_ADQUIRIENTES, 
    FETCH_TIPOS_SEXO, 
    FETCH_TIPOS_CONCEPTOS, 
    LOADING_TIPOS_CONCEPTOS
} from './types';
import {
    getSituacionIva, 
    getTiposAdquirientes, 
    getTiposSexo, 
    getTiposConceptos 
} from "../api/axios";

export const fetchSituacionIva = () => async dispatch => {
    let array = getSituacionIva();
    array.then((value) => {
        dispatch({
            type: FETCH_SITUACION_IVA,
            payload: value.tiposIva
        });
    })
}

export const fetchTiposAdquirientes = () => async dispatch => {
    let array = getTiposAdquirientes();
    array.then((value) => {
        dispatch({
            type: FETCH_TIPOS_ADQUIRIENTES,
            payload: value.tiposAdquirientes
        });
    })
}

export const fetchTiposSexo = () => async dispatch => {
    let array = getTiposSexo();
    array.then((value) => {
        dispatch({
            type: FETCH_TIPOS_SEXO,
            payload: value.tipoSexo
        });
    })
}

export const fetchListaConceptos = () => async dispatch => {
    
    dispatch({
        type: LOADING_TIPOS_CONCEPTOS,
        payload: true
    });

    let array = getTiposConceptos();

    array.then((value) => {

        dispatch({
            type: LOADING_TIPOS_CONCEPTOS,
            payload: false
        });

        dispatch({
            type: FETCH_TIPOS_CONCEPTOS,
            payload: value.listaConceptoNovedades
        });
    })
}